var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlustrationOnboardingMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 109,
    viewBox: "0 0 62 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1825 74.3649C40.9021 74.3649 35.0001 68.4629 35.0001 61.1825C35.0001 53.902 40.9021 48 48.1825 48C55.463 48 61.365 53.902 61.365 61.1825C61.365 68.4629 55.463 74.3649 48.1825 74.3649Z",
    fill: "#E1E4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2471 0H17.4996C18.9951 23.0158 34.7538 23.3699 34.7538 23.3699C34.7538 23.3699 17.3769 23.7382 17.3769 50.333C17.3769 23.7382 0 23.3699 0 23.3699C0 23.3699 15.7516 23.0158 17.2471 0Z",
    fill: "url(#paint0_linear_1101_10974)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4607 108.594C12.2357 108.594 8.00006 104.208 8.00006 98.797C8.00006 93.3863 12.2357 89 17.4607 89C22.6857 89 26.9214 93.3863 26.9214 98.797C26.9214 104.208 22.6857 108.594 17.4607 108.594Z",
    fill: "#8FFBBF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1101_10974",
    x1: -19.0289,
    y1: -6.27842,
    x2: 76.9667,
    y2: 58.3895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F3FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustrationOnboardingMobile);
export default __webpack_public_path__ + "static/media/IlustrationOnboarding-mobile.49988cf6bc9150b0072d5a1337fbfadf.svg";
export { ForwardRef as ReactComponent };